export default __webpack_public_path__ + "static/media/e5b4ee418bd3d811f2158295865a0f37.svg";